export const SHUTTERBUG_TRIAL_DAYS_FALLBACK = 7;
